import Input from '../../components/form/PasswordInput'

export default function PasswordInput (props) {
  return (
    <Input
      {...props}
    />
  )
}
